export default __webpack_public_path__ + "static/media/mechanism_long.800c6a4f.gif";